/* 评分功能 */
export const WEBSITE_RATING = {

  REASON_LIST: [
    {
      label: '素材量少',
    },
    {
      label: '会员价格高',
    },
    {
      label: '没有找到满意的内容',
    },
    {
      label: '网络经常故障',
    },
    {
      label: '更新速度慢',
    },
    {
      label: '付费内容占比高',
    },
    {
      label: '文件损坏或缺失',
    },
    {
      label: '分类复杂不会用',
    },
   /* {
      label: '其他',
    }*/
  ],
}
